<template>
  <div class="authorizationLicense" v-loading="loading">
    <div class="licenseContent">
      <div class="licenseTitle">
        <span>紫光云UniCloud SDS存储授权申请</span>
      </div>
      <text-tip v-if="tipShow" class="textTip" @closeTip="closeTip">
        <div>请严格按照要求提交信息，以免影响授权申请！信息提交完成后，预计3-5天会通过邮箱发送，请注意查收！</div>
      </text-tip>
      <div class="licenseForm">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="项目名称" prop="projectName">
                <el-input v-model="form.projectName" placeholder="请输入项目名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道经理" prop="channelManager">
                <el-input v-model="form.channelManager" placeholder="请输入渠道经理"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email" placeholder="请准确输入您的电子邮箱，以便发送授权文件"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="phoneNumber">
                <el-input v-model="form.phoneNumber" placeholder="请输入您的手机号码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="key文件上传" prop="keyFile">
                <el-upload
                  class="saveCode"
                  ref="uploadKeyFile"
                  drag
                  action="#"
                  :limit="1"
                  :on-change="checkKeyFile"
                  :http-request="uploadKeyFile"
                  :show-file-list="false"
                  :multiple="false">
                  <img class="imgClass" src="../../assets/img/upload.svg" >
                  <div class="textClass">支持拖拽上传，支持.key格式</div>
                </el-upload>
                <p class="uploadName">{{form.keyFile}}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上传附件" prop="excelFile">
                <span slot="label">上传附件
                  <!-- <el-button type="text" icon="el-icon-download" @click="download">下载附件模板</el-button> -->
                  <a class="download" 
                  href="https://unicloudexport1.oss-cn-north-1.unicloudsrv.com/SDS/License/Activation/Application/%E6%8E%88%E6%9D%83%E7%94%B3%E8%AF%B7%E6%A8%A1%E7%89%88.xlsx" 
                  target="_blank"><i class="el-icon-download"></i>下载附件模板</a>
                </span>
                <el-upload
                  class="saveCode"
                  ref="uploadExcelFile"
                  drag
                  action="#"
                  :limit="1"
                  :on-change="checkExcelFile"
                  :http-request="uploadExcelFile"
                  :show-file-list="false"
                  :multiple="false">
                  <img class="imgClass" src="../../assets/img/upload.svg" >
                  <div class="textClass">支持拖拽上传，支持.xlsx格式</div>
                </el-upload>
                <p class="uploadName">{{form.excelFile}}</p>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="licenseBtn">
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import textTip from "~/components/text-tip.vue";
import authorizationReq from "~/request/authorizationReq";

export default {
  components:{
    textTip,
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      // const phoneTest = /^1((3[\d])|(4[5,6,7,9])|(5[0-3,5-9])|(6[5-7])|(7[0-8])|(8[\d])|(9[1,8,9]))\d{8}$/;
      const phoneTest = /^1\d{10}$/;
      if (value&&value.length==0) {
        callback(new Error('请输入手机号'));
      } else if (!phoneTest.test(value)) {
        callback(
          new Error("请输入正确的手机号码")
        );
      }
      else {
        callback();
      }
    };
    const validateEmailAddress = (rule, value, callback) => {
      const email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (value.length==0) {
        callback(new Error('请输入邮箱'));
      }else if(value.length>64){
        callback(new Error('邮箱最大长度64位'));
      } else if (!email.test(value)) {
        callback(
          new Error("请输入正确邮箱")
        );
      }
      else {
        callback();
      }
    };
    const validateKeyFile = (rule, value, callback) => {
      let testmsg = value.substring(value.lastIndexOf('.') + 1).toLowerCase();
      if (testmsg === 'key') {
        callback();
      } else {
        callback(new Error('仅key格式文件'));
      }      
      this.$refs.uploadKeyFile.clearFiles();
    };    
    const validateExcelFile = (rule, value, callback) => {
      let testmsg = value.substring(value.lastIndexOf('.') + 1).toLowerCase();
      if (testmsg === 'xlsx') {
        callback();
      } else {
        callback(new Error('仅xlsx格式文件'));
      }   
      this.$refs.uploadExcelFile.clearFiles();   
    };
    return {
      loading: false,
      tipShow: true,
      form: {
        projectName: '',
        channelManager: '',
        email: '',
        phoneNumber: '',
        keyFile: '',
        excelFile: '',
      },
      keyFileData: null,
      excelFileData: null,
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        channelManager: [
          { required: true, message: '请输入渠道经理', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: validateEmailAddress, trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        keyFile:  [
          { required: true, message: '请上传key文件', trigger: 'blur' },
          { validator: validateKeyFile, trigger: 'blur' }
        ],
        excelFile:  [
          { required: true, message: '请上传附件', trigger: 'blur' },
          { validator: validateExcelFile, trigger: 'blur' }
        ],
      },
      uploadDisabled: false,
    };
  },

  methods: {    
    closeTip(){
      this.tipShow = false;
    },
    checkKeyFile(file){
      this.form.keyFile = file.name;
      this.$refs.form.validateField('keyFile');
    },
    checkExcelFile(file){
      this.form.excelFile = file.name;
      this.$refs.form.validateField('excelFile');
    },
    uploadKeyFile(file){
      this.keyFileData = file.file;
    },
    uploadExcelFile(file){
      this.excelFileData = file.file;
    },
    // download() {
    //   let downloadElement = document.createElement('a');
    //   downloadElement.href = 'https://unicloudexport1.oss-cn-north-1.unicloudsrv.com/SDS/License/Activation/Application/%E6%8E%88%E6%9D%83%E7%94%B3%E8%AF%B7%E6%A8%A1%E7%89%88.xlsx';
    //   //设置下载文件名字
    //   downloadElement.download = '%E6%8E%88%E6%9D%83%E7%94%B3%E8%AF%B7%E6%A8%A1%E7%89%88.xlsx';
    //   document.body.appendChild(downloadElement);
    //   downloadElement.click();
    //   //释放资源
    //   document.body.removeChild(downloadElement);
    //   window.URL.revokeObjectURL(href);
    // },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = new FormData()
          data.append('projectName', this.form.projectName);
          data.append('channelManager', this.form.channelManager);
          data.append('email', this.form.email);
          data.append('phoneNumber', this.form.phoneNumber);
          data.append('keyFile', this.keyFileData);
          data.append('excelFile', this.excelFileData);
          this.loading = true;
          authorizationReq.submitApplication(data).then(res => {
            if(res.status) {
              this.$notify({
                title: '成功',
                message: '提交成功',
                type: 'success',
              });
              this.keyFileData = null;
              this.excelFileData = null;
              this.$refs.form.resetFields();
              this.$refs.form.clearValidate();
            } else {
              this.$notify({
                title: '失败',
                message: res.msg || '提交失败',
                type: 'error',
              });
            }
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.authorizationLicense {
  background: #ffffff;
  // margin: 20px;
  height: 100%;
  // max-width: 1200px;
  display: flex;
  flex-direction: column;
  .licenseContent {
    .rightFlexItem {
    }
    margin: 0 auto;
    // margin: 0 291px;
    // height: 100%;
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
      width: 750px;
    }
    @media (min-width: 992px) {
      width: 970px;
    }
    @media (min-width: 1200px) {
      width: 1200px;
    }
    // 小于 1532 px
    @media screen and (max-width: 1532px) {
      margin-top: 32px;
    }

    // min-width: 1200px;
    .licenseTitle {
      height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      padding: 20px 0;
      .clickText {
        cursor: pointer;
        color: @currentColor;
      }
      .licenseTitleIcon {
        margin-left: 7px;
        cursor: pointer;
        font-size: 16px;
      }
    }
    .licenseForm {
      margin: 15px 0 30px 0;
      padding: 40px 50px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      .el-row {
        margin-bottom: 20px;
      }      
    }
    .licenseBtn {
      text-align: center;
      .el-button {
        width: 120px;
      }
    }
    /deep/ .el-form-item__label {
      font-size: 14px;
    }    
    .saveCode{
      /deep/ .el-upload-dragger{
        background: #F4F6FA;
        border-radius: 4px;
        border: 1px solid #E6E8EC;
        position: relative;
        text-align: center;
        .imgClass{
          width: 35px;
          height: 33px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -80%);
        }
        .textClass{
          position: relative;
          top: 138px;
          font-weight: 400;
          color: #A3A5A9;
          line-height: 14px;
        }
      }
    }
    .download {
      margin-left: 50px;
      color: #ab41a1;
      text-decoration: none;
    }
    .uploadName {
      margin: 0;
    }
  }
}
#app .authorizationLicense {
  /deep/ .el-form-item__label {
    font-size: 14px;
  }
} 
</style>